export default "__VITE_ASSET__WIigI3qK__"